export var EDocumentCustomFilter;
(function (EDocumentCustomFilter) {
    EDocumentCustomFilter["Active"] = "ACTIVE";
    EDocumentCustomFilter["Archived"] = "ARCHIVED";
    EDocumentCustomFilter["ExcludeInternalDocuments"] = "EXCLUDE_INTERNAL_DOCUMENTS";
    EDocumentCustomFilter["IncludeTenantIds"] = "INCLUDE_TENANT_IDS";
})(EDocumentCustomFilter || (EDocumentCustomFilter = {}));
